import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const GroupsIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M11.4167 3.625C11.4167 5.07475 10.2228 6.25 8.75 6.25C7.27724 6.25 6.08333 5.07475 6.08333 3.625C6.08333 2.17525 7.27724 1 8.75 1C10.2228 1 11.4167 2.17525 11.4167 3.625Z" stroke={color} strokeWidth="1.5" />
    <Path d="M6.08333 12.375C6.08333 13.8247 4.88943 15 3.41667 15C1.94391 15 0.75 13.8247 0.75 12.375C0.75 10.9253 1.94391 9.75 3.41667 9.75C4.88943 9.75 6.08333 10.9253 6.08333 12.375Z" stroke={color} strokeWidth="1.5" />
    <Path d="M16.75 12.375C16.75 13.8247 15.5561 15 14.0833 15C12.6106 15 11.4167 13.8247 11.4167 12.375C11.4167 10.9253 12.6106 9.75 14.0833 9.75C15.5561 9.75 16.75 10.9253 16.75 12.375Z" stroke={color} strokeWidth="1.5" />
  </Svg>
);

GroupsIcon.displayName = 'GroupsIcon';
